import React from 'react'
import cx from 'classnames'
import './Button.scss'

const noop = () => {}

const Button = ({
  className = undefined,
  label = null,
  title,
  primary = false,
  outline = false,
  warning = false,
  submit = false,
  small = false,
  text = false,
  icon = false,
  onClick = submit ? noop : undefined,
  disabled = !onClick,
  children,
  ...props
}) => (
  <button
    title={title}
    tabIndex="0"
    type={submit ? 'submit' : 'button'}
    className={cx('Button', {
      icon,
      outline,
      warning,
      primary,
      small,
      text,
      [className]: Boolean(className),
    })}
    onClick={e => {
      if (!submit) e.preventDefault()
      e.stopPropagation()
      onClick && onClick(e)
    }}
    {...props}
    disabled={disabled}
  >
    {label && <div className="buttonLabel">{label}</div>}
    {children}
  </button>
)

export default Button
